import React from 'react';
import './Loader.css';

export default (props) => (
  <div className="loading-overlay-outer">
    <div className="loader mr-2"></div>
    {props.text || 'Loading...'}
  </div>
);
